module.exports = __webpack_public_path__ + "img/ic_baby_move.062034da.png";